<template>
    <!-- アレルゲン検索パーツ -->
    <div class="pt035" id="pt035" v-cloak>
        <!-- アレルギー物質で絞り込み検索  -->
        <div class="allergenSearchTitle mb-3" @click="changeAllergenArea()">
            <span class="allergenSearchInfo mr-2">{{$t('pt035.labels.productAllergenSearch')}}</span>
            <span v-if="!openAllergenArea" class="allergenSearchOpen">{{$t('pt035.labels.open')}}</span>
            <span v-else class="allergenSearchOpen">{{$t('pt035.labels.close')}}</span>
        </div>
        <!-- アレルギー物質で絞り込み検索エリア -->
        <div :class="'allergenSearchSelect mb-3 ' + (openAllergenArea ? 'allergenSelectOpen' : 'allergenSelectClose')">

            <div v-html="pt035Init.descriptionInfo['1']"></div>

            <div class="allergenSelectArea col-12 mb-4 input-group">
                <div :class="'allergenSet allergenSet_'+allergyMaterial.KEY+' col-3'" v-for="(allergyMaterial,index) in pt035Init.allergyMaterialList" :key="allergyMaterial.KEY">
                    <input :id="'allergenCheck_'+allergyMaterial.KEY" :value="allergyMaterial.KEY" v-model="allergyMaterialChkList[index]" :class="'allergenCheck allergenCheck_'+allergyMaterial.KEY+' form-check-input input-classification'" type="checkbox">
                    <label :for="'allergenCheck_'+allergyMaterial.KEY" :class="'allergenNm allergenNm_'+allergyMaterial.KEY">{{allergyMaterial.VALUE}}</label>
                </div>
            </div>

            <div v-html="pt035Init.descriptionInfo['2']"></div>

            <div class="text-center">
                <button class="btnSuccess" @click="pt035Search()">{{$t('pt035.buttons.searchButton')}}</button>
            </div>

            <div v-html="pt035Init.descriptionInfo['3']"></div>
        </div>
    </div>
</template>
<script>

import common from "assets/js/common";
import axios from "assets/js/request";
import SiteConstants from 'assets/const/SiteConstants.json';

export default {
    name: "pt035ProductAllergenSearchParts",
    data() {
        return {
            SiteConstants: SiteConstants,
            site: "",

            errMsg: '',
            pt035Init:{
                allergyMaterialList: [],
            },
            pt035QueryData:{
                pageNo: null,
                allergyMaterialKbn: null,
            },
            pt035ParamData:{},

            allergyMaterialChkList: [],
            openAllergenArea: false,
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt035Init = _this.ptInitData;

            _this.makeAllergenList();
            
        }else{
            // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT035 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt035Init = response.data;

                _this.makeAllergenList();

            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    methods: {
        // 選択されたアレルギー物質を除外して検索する
        pt035Search: function(){
            var _this = this;
            var allergyMaterialKbn = "";

            for(var i=0; i<_this.allergyMaterialChkList.length; i++){
                if(_this.allergyMaterialChkList[i]){
                    allergyMaterialKbn = allergyMaterialKbn + _this.pt035Init.allergyMaterialList[i].KEY + ",";
                }
            }
            allergyMaterialKbn = allergyMaterialKbn.slice(0, -1);

            if(allergyMaterialKbn) {
                _this.pt035QueryData.allergyMaterialKbn = allergyMaterialKbn;
            }else{
                _this.pt035QueryData.allergyMaterialKbn = null;
            }
            _this.pt035QueryData.pageNo = 2;
            _this.pt035QueryData.categoryCd = _this.pt035ParamData.categoryCd;

            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:_this.pt035QueryData, params:_this.pt035ParamData});
        },

        // チェックボックスのエリアを表示する
        changeAllergenArea: function(){
            var _this = this;
            if(_this.openAllergenArea){
                _this.openAllergenArea = false;
            }else{
                _this.openAllergenArea = true;
            }
        },

        // アレルゲンリストの作成
        makeAllergenList: function(){
            var _this = this;
            var selectList = [];

            if(_this.pt035Init.allergyMaterialList.length > 0){
                _this.allergyMaterialChkList = Array(_this.pt035Init.allergyMaterialList.length);
                _this.allergyMaterialChkList.fill(false);

                if(_this.pt035QueryData.allergyMaterialKbn) {
                    selectList = _this.pt035QueryData.allergyMaterialKbn.split(",");
                    for(var i=0; i<selectList.length; i++){
                        var allergyMaterialNo = _this.pt035Init.allergyMaterialList.findIndex(item => item.KEY == selectList[i]);
                        _this.allergyMaterialChkList[allergyMaterialNo] = true;
                    }
                }
            }
        }
    },
    created(){
        var _this = this;
        // Get data from params and query
        var paramsData = _this.$route.params;
        var queryData = _this.$route.query;

        if(Object.keys(paramsData).length > 0){
            _this.pt035ParamData = Object.assign(_this.pt035ParamData, paramsData);
        }
        if(Object.keys(queryData).length > 0){
            _this.pt035QueryData = Object.assign(_this.pt035QueryData, queryData);
        }
    }
}
</script>
<style scoped>
    #pt035 .allergenSelectClose {
        display: none;
    }
</style>